import PropTypes from 'prop-types'
import InfoModal from '../../../common/InfoModal'

import { ReactComponent as WarningIcon } from '../../../../assets/images/common/icons/warning-icon.svg'
import colors from '../../../../assets/styles/globals.scss'

const DefaultBodyText = () => (
  <>
    <p>
      This package has active or past enrollments, so it cannot be deleted.
    </p>
    <p>
      Archiving will remove this package from all associated programs so no new enrollment requests can be created.
    </p>
    <p>
      You will still be able to view its details.
    </p>
    <p style={{ color: colors.red }}>
      <strong>This action is permanent and cannot be undone.</strong>
    </p>
  </>
)

const SingleWithinProgramBodyText = () => (
  <>
    <p>
      This package has active or past enrollments and <b>may be the only online payment option for at least one program.</b>
    </p>
    <p>
      <b>If you archive it:</b>
      <ul>
        <li>Those programs will immediately switch to offline-only payments.</li>
        <li>Online payments will be disabled until a new online package is added.</li>
      </ul>
    </p>
    <p>Programs can only accept online payments if they have an active online package assigned.</p>
    <p>After archiving you will still be able to view the package details.</p>
    <p style={{ color: colors.red }}>
      <strong>This action is permanent and cannot be undone.</strong>
    </p>
  </>
)

const ArchivePackageConfirmationModal = ({ isSingleWithinProgram, ...props }) => (
  <InfoModal
    title='Archive Package?'
    icon={<WarningIcon />}
    buttonMessage='Archive'
    {...props}
  >
    <div className='mx-4 text-left'>
      {isSingleWithinProgram ? <SingleWithinProgramBodyText /> : <DefaultBodyText />}
    </div>
  </InfoModal>
)

ArchivePackageConfirmationModal.propTypes = {
  isSingleWithinProgram: PropTypes.bool,
}

export default ArchivePackageConfirmationModal
